import Lottie from "lottie-react";
import { useActivity } from "../../../../../../../context/ActivityContext";
import box from "../../../../../../../asset/lotties/box.json";
import styles from "./inbox.module.scss";

export default function Inbox() {
  const { activities, removeActivity } = useActivity();

  const formatTimeAgo = (date: Date) => {
    const now = new Date();
    const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);

    if (diffInSeconds < 60) return "Just now";
    if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)}m ago`;
    if (diffInSeconds < 86400)
      return `${Math.floor(diffInSeconds / 3600)}h ago`;
    return `${Math.floor(diffInSeconds / 86400)}d ago`;
  };

  const getActivityIcon = (type: string, action: string) => {
    switch (type) {
      case "create":
        return "➕";
      case "delete":
        return "🗑️";
      case "update":
        return "✏️";
      case "copy":
        return "📋";
      default:
        return "📄";
    }
  };

  const getActivityColor = (type: string) => {
    switch (type) {
      case "create":
        return "#4CAF50";
      case "delete":
        return "#f44336";
      case "update":
        return "#2196F3";
      case "copy":
        return "#FF9800";
      default:
        return "#757575";
    }
  };

  // If no activities, show the original empty state
  if (activities.length === 0) {
    return (
      <div className={styles.inbox}>
        <Lottie animationData={box} className={styles.inbox_box} />
        <h4 className={styles.inbox__heading}>Inbox is currently empty</h4>
        <p className={styles.inbox__info}>
          {" "}
          Every activity will be displayed here.{" "}
        </p>
      </div>
    );
  }

  // Show activities list
  return (
    <div className={styles.inbox_activities}>
      <div className={styles.inbox_activities_header}>
        <h4 className={styles.inbox_activities_title}>Recent Activities</h4>
        <span className={styles.inbox_activities_count}>
          {activities.length} activities
        </span>
      </div>

      <div className={styles.inbox_activities_list}>
        {activities.map((activity) => (
          <div key={activity.id} className={styles.activity_item}>
            <div
              className={styles.activity_icon}
              style={{ backgroundColor: getActivityColor(activity.type) }}
            >
              {getActivityIcon(activity.type, activity.action)}
            </div>

            <div className={styles.activity_content}>
              <div className={styles.activity_header}>
                <span className={styles.activity_name}>{activity.name}</span>
                <span className={styles.activity_time}>
                  {formatTimeAgo(activity.timestamp)}
                </span>
              </div>
              <p className={styles.activity_description}>
                {activity.description}
              </p>
            </div>

            <button
              className={styles.activity_remove}
              onClick={() => removeActivity(activity.id)}
              title="Remove activity"
            >
              ×
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
